import { useEffect, useContext, useState, useMemo } from 'react'
import { useUserStore } from 'Store/User'
import { UserListViewContext } from './Context'
import { UserFormModalContext } from '../Form/Context'
import { TableContext } from 'Context/Table'

import ActionCell from 'Presentation/Components/Table/Components/CustomActionCell'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import { shallow } from 'zustand/shallow'

const ViewModel = () => {
  const { rawData, getAll, setSelected, clearState, deleteUser } = useUserStore(
    state => ({
      rawData: state.data,
      getAll: state.getAll,
      deleteUser: state.delete,
      setSelected: state.setSelected,
      clearState: state.clearState,
    }),
    shallow
  )

  const { toggleUserModal } = useContext(UserListViewContext)
  const { updateFormType } = useContext(UserFormModalContext)
  const {
    // currentSorting,
    updateLoading,
    updateError,
    updatePagination,
    updateDefaultSorting,
    resetState: resetTableState,
  } = useContext(TableContext)

  const [searchText, setSearchText] = useState('')
  const data = useMemo(() => {
    if (searchText === '') {
      return rawData
    } else {
      return rawData.filter((item: any) => {
        const fullName = item.fullName.toLowerCase()
        // const username = item.username.toLowerCase()
        // const roleTitle = item.roleTitle.toLowerCase()
        const search = searchText.toLowerCase()
        if (fullName.includes(search)) {
          return true
        }
        return false
      })
    }
  }, [rawData, searchText])

  const fetchData = async () => {
    try {
      updateLoading(true)
      await getAll()
      updateLoading(false)
    } catch (err: any) {
      updateLoading(false)
      updateError(err.message)
    }
  }
  const handleOpenUserModal = () => {
    toggleUserModal(true)
    updateFormType('add')
  }

  const setupTable = () => {
    updateDefaultSorting('id', true)
    updatePagination(true)
  }

  const editUser = (id: string) => {
    const finded = data.find((item: any) => item.id === id)
    if (!finded) return
    else {
      setSelected(finded)
      toggleUserModal(true)
      updateFormType('edit')
    }
  }

  const askDeleteUser = async (id: number) => {
    const { isConfirmed } = await Swal.fire({
      title: 'คุณต้องการที่จะลบผู้ใช้งานนี้ใช่หรือไม่?',
      text: 'ผู้ใช้งานที่ถูกลบไปแล้วจะไม่สามารถกู้คืนได้',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    })
    if (isConfirmed) {
      const { success, data } = await deleteUser(id)
      if (success) {
        toast.success('ลบผู้ใช้งานสำเร็จ')
        fetchData()
      } else {
        toast.error(data)
      }
    }
  }

  const TABLE_CONFIGS: any[] = [
    // {
    //   Header: 'ID',
    //   accessor: 'id',
    //   width: 150,
    //   minWidth: 150,
    //   Cell: ({ value }: any) => {
    //     return <span className='text-gray-800'>{value}</span>
    //   },
    // },
    {
      Header: 'ชื่อ-นามสกุล',
      accessor: 'fullName',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value ?? '-'}</span>
      },
    },
    {
      Header: 'อีเมล',
      accessor: 'username',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value ?? '-'}</span>
      },
    },
    {
      Header: 'ตำแหน่ง',
      accessor: 'roleTitle',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value ?? '-'}</span>
      },
    },
    {
      Header: '',
      accessor: 'action',
      width: 100,
      minWidth: 100,
      Cell: ({ row }: any) => (
        <ActionCell
          hideDuplicate
          hideView
          id={row.index + 1}
          onClickEdit={() => editUser(row.original.id)}
          onClickDelete={() => askDeleteUser(row.original.id)}
        />
      ),
      disableSortBy: true,
    },
  ]

  // Initial Fetch and Initial Table Setup
  useEffect(() => {
    const action = async () => {
      setupTable()
      await fetchData()
    }

    action()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Reset Hook
  useEffect(() => {
    return () => {
      resetTableState()
      clearState()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    searchText,
    setSearchText,
    data,
    TABLE_CONFIGS,
    handleOpenUserModal,
  }
}

export default ViewModel
